import request from 'sb-request'
import { reducers } from 'redux/core'


const fetch = () => {
  reducers.view.reviewsPage.setFetchingStatus(true)

  return request.get('rest/external-reviews')
    .then(
      (data) => reducers.view.reviewsPage.set(data),
      () => {
        reducers.view.reviewsPage.setFetchingStatus(false)
        return Promise.reject()
      }
    )
}

const reset = reducers.view.reviewsPage.reset // eslint-disable-line


export default {
  reset,
  fetch,
}
